import {
  poseAsSelf,
  poseAsUser,
  requestLoginToken,
  isPosing
} from '@collectivehealth/cog/dist/posing';

import app from 'app';

app.factory('Posing', $q => ({
  isPosing,
  poseAsSelf: (...args) => $q.when(poseAsSelf(...args)),
  poseAsUser: (...args) => $q.when(poseAsUser(...args)),
  poseByRequestingToken: userId => $q.when(poseAsUser(userId)),
  poseWithExistingToken: newSubdomain => $q.when(poseAsSelf(newSubdomain)),
  requestLoginToken: (...args) => {
    let options;

    // The old API took two arguments: userId, subdomain
    if (typeof args[0] !== 'object') {
      options = {
        userId: args[0],
        subdomain: args[1]
      };
    } else {
      options = args[0];
    }

    return $q.when(requestLoginToken(options));
  }
}));
